import React, { FC } from 'react'

import { SelectAssignUsersInput } from 'src/components/molecules'

import { useGetUsers } from 'src/hooks'
import { InternalUserEntity, ProfileEntity, UserEntity } from 'src/types'

type Props = {
  excludedInternalUsers?: UserEntity[]
  profile?: ProfileEntity
  onSelectInternalUser: (user: InternalUserEntity) => void
  onBatchSelect?: (users: InternalUserEntity[]) => void
  rounded?: boolean
  className?: string
}

export const SelectInternalUsersInput: FC<Props> = ({
  excludedInternalUsers = [],
  profile,
  onSelectInternalUser,
  onBatchSelect,
  rounded,
  className,
}) => {
  const { loading, users: internalUsers } = useGetUsers()

  const handleOnSelectUser = (selectedUser: UserEntity) => {
    const selectedInternalUser = internalUsers.find(
      internalUser => selectedUser.id === internalUser.id
    )
    selectedInternalUser && onSelectInternalUser(selectedInternalUser)
  }

  const handleOnBatchSelect = (selectedUsers: UserEntity[]) => {
    const selectedInternalUsers = internalUsers.filter(internalUser =>
      selectedUsers.some(selectedUser => selectedUser.id === internalUser.id)
    )
    onBatchSelect?.(selectedInternalUsers)
  }

  return (
    <div className={className}>
      {!loading && internalUsers && (
        <SelectAssignUsersInput
          targetUsers={internalUsers}
          profile={profile}
          onSelectUser={handleOnSelectUser}
          onBatchSelect={handleOnBatchSelect}
          excludedUsers={excludedInternalUsers}
          rounded={rounded}
        />
      )}
    </div>
  )
}
